"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function LoaderspinnerGradientOutline(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#prefix__loaderspinner-gradient-outline__clip0_13467_334)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3C73B1",
    d: "M7.983 0h.034c.227 0 .412.184.412.411v2.606a.411.411 0 01-.412.412h-.034a.411.411 0 01-.411-.412V.411c0-.227.184-.411.411-.411z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#487BB6",
    d: "M11.046.603l.031.013c.21.087.31.327.223.537l-.997 2.408a.412.412 0 01-.538.222l-.031-.013a.411.411 0 01-.223-.537l.997-2.408a.411.411 0 01.538-.222z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5484BB",
    d: "M13.645 2.331l.024.024c.16.161.16.421 0 .582L11.826 4.78a.411.411 0 01-.582 0l-.024-.025a.412.412 0 010-.581l1.843-1.843c.16-.16.42-.16.582 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#618DC0",
    d: "M15.384 4.923l.014.031a.411.411 0 01-.223.538l-2.407.997a.411.411 0 01-.538-.222l-.013-.032a.412.412 0 01.223-.538l2.407-.997c.21-.087.45.013.537.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6D96C5",
    d: "M16 7.983v.034a.411.411 0 01-.411.412h-2.606a.411.411 0 01-.412-.412v-.034c0-.227.185-.411.412-.411h2.606c.227 0 .411.184.411.411z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A9FCA",
    d: "M15.398 11.046l-.013.031a.412.412 0 01-.538.223l-2.407-.997a.412.412 0 01-.223-.538l.013-.031a.411.411 0 01.537-.223l2.408.997c.21.087.31.328.223.538z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7DA9D3",
    d: "M13.669 13.645l-.024.024a.411.411 0 01-.582 0l-1.843-1.843a.411.411 0 010-.582l.024-.024c.161-.16.422-.16.582 0l1.843 1.843c.16.16.16.42 0 .582z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A4C2E0",
    d: "M4.954 15.398l-.031-.013a.412.412 0 01-.223-.538l.997-2.407a.411.411 0 01.538-.223l.031.013c.21.087.31.328.223.537l-.997 2.408a.411.411 0 01-.538.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8AB2D7",
    d: "M11.077 15.384l-.031.014a.411.411 0 01-.538-.223l-.997-2.407a.411.411 0 01.223-.538l.031-.013c.21-.087.45.013.538.223l.997 2.407a.411.411 0 01-.223.537z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#98BBDC",
    d: "M8.017 16h-.034a.411.411 0 01-.411-.411v-2.606c0-.227.184-.412.411-.412h.034c.227 0 .412.185.412.412v2.606a.411.411 0 01-.412.411z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2CBE4",
    d: "M2.355 13.669l-.024-.024a.411.411 0 010-.582l1.842-1.843c.161-.16.422-.16.582 0l.025.024c.16.161.16.422 0 .582L2.937 13.67a.411.411 0 01-.582 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFD4E9",
    d: "M.616 11.077l-.014-.031a.411.411 0 01.223-.538l2.408-.997c.21-.087.45.013.537.223l.013.031a.412.412 0 01-.222.538l-2.408.997a.412.412 0 01-.537-.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CDDDEE",
    d: "M0 8.017v-.034c0-.228.184-.412.411-.412h2.606c.227 0 .412.184.412.412v.034a.411.411 0 01-.412.411H.411A.411.411 0 010 8.017z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8EFF7",
    d: "M.603 4.954l.013-.031a.411.411 0 01.537-.223l2.408.997c.21.087.31.328.222.538l-.013.032a.412.412 0 01-.537.222L.825 5.492a.411.411 0 01-.222-.538zM2.331 2.355l.024-.024c.161-.16.421-.16.582 0L4.78 4.173c.16.161.16.422 0 .582l-.025.025a.412.412 0 01-.581 0L2.33 2.937a.412.412 0 010-.582z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F8FB",
    d: "M4.923.616l.031-.014c.21-.086.451.013.538.223l.997 2.408a.412.412 0 01-.222.537l-.032.013a.411.411 0 01-.538-.222L4.7 1.153a.412.412 0 01.223-.537z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__loaderspinner-gradient-outline__clip0_13467_334"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}

LoaderspinnerGradientOutline.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
LoaderspinnerGradientOutline.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = LoaderspinnerGradientOutline;
exports["default"] = _default;